import { useState } from 'react';

// components
import AddAdmin from 'components/admin/AddAdmin';
import VestToken from 'components/admin/VestToken';
import Blacklist from 'components/admin/Blacklist'

import clsx from 'clsx';
import classes from './Tab.module.scss';
import { APP_CONFIG } from 'config';

const BLOCK = {
  ADD_ADMIN: 'Add admin',
  ADD_USER: 'Add user',
  BLACKLIST_USER: "Blacklist User"
};

interface tabItemProps {
  isActive: boolean;
  label: string;
  onClick: () => void;
}

const Tab = () => {
  const [stage, setStage] = useState(BLOCK.ADD_ADMIN);
  const navBarOptions: any = [
    {
      title: 'Add Admin',
      onClick: () => setStage(BLOCK.ADD_ADMIN),
      selected: stage === BLOCK.ADD_ADMIN,
    },
    {
      title: `Vest ${APP_CONFIG.VESTING_TOKEN}`,
      onClick: () => setStage(BLOCK.ADD_USER),
      selected: stage === BLOCK.ADD_USER,
    },
    {
      title: 'Blacklist',
      onClick: () => setStage(BLOCK.BLACKLIST_USER),
      selected: stage === BLOCK.BLACKLIST_USER,
    },
  ];

  let cardContent = null;
  switch (stage) {
    case BLOCK.ADD_ADMIN:
      cardContent = <AddAdmin />;
      break;
    case BLOCK.ADD_USER:
      cardContent = <VestToken />;
      break;
    case BLOCK.BLACKLIST_USER:
      cardContent = <Blacklist />
  }

  return (
    <div>
      <div className={classes.tab}>
        {navBarOptions.map((item: any, i: number) => (
          <TabItem key={i} label={item.title} onClick={item.onClick} isActive={item.selected} />
        ))}
      </div>
      <div className={classes.card}>{cardContent}</div>
    </div>
  );
};

const TabItem = ({ label, onClick, isActive }: tabItemProps) => {
  return (
    <div className={clsx(classes.tabListItem, { [classes.active]: isActive })} onClick={onClick}>
      <p>{label}</p>
    </div>
  );
};

export default Tab;
